import {
  AppDispatch,
  changePassword,
  changePasswordRequest,
  login,
} from "@src/redux";
import { Form, Button } from "antd";
import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import CurrentPassword from "../change-password/change-password-form-elements/CurrentPassword";
import NewPassword from "../change-password/change-password-form-elements/NewPassword";
import ConfirmPassword from "../change-password/change-password-form-elements/ConfirmPassword";

const ForcePasswordChanges = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { result: passwordChangeResult, loading: passwordChangeLoading } =
    useSelector(changePassword);
  const { result: loginResults } = useSelector(login);

  const handlePasswordChange = (passwordValues: any) => {
    dispatch(
      changePasswordRequest({
        data: {
          oldPassword: passwordValues?.oldPassword,
          newPassword: passwordValues?.new_password,
          userId: loginResults?.userId || "",
        },
      })
    );
  };

  return (
    <Form layout="vertical" form={form} onFinish={handlePasswordChange}>
      <CurrentPassword />
      <NewPassword />
      <ConfirmPassword />

      <Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            className="force-password-change"
            htmlType="submit"
            loading={passwordChangeLoading}
          >
            {t("change")}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default ForcePasswordChanges;
